import { ChangePartnerMenuWebComponent } from './component/ChangePartnerMenuWebComponent';
import { WEB_COMPONENT_CHANGE_PARTNER_MENU } from '../../../webcomponents.constants';

export { ChangePartnerMenuWebComponent };

window.customElements.define(WEB_COMPONENT_CHANGE_PARTNER_MENU, ChangePartnerMenuWebComponent);
